import type React from 'react';

import { RoleGeneralInfo } from '@vlabs/monokit/entities/roles';
import { EditRoleButton } from '@vlabs/monokit/features/point/edit-role';
import { Page, PageContent, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { RolePermissions } from '@vlabs/monokit/widgets/roles/role-permissions';
import { useHasPermission } from '@vlabs/permissions';

import { RoleDetailsPageHeader } from './header/RoleDetailsPageHeader';
import st from './RoleDetailsPage.module.sass';
import { useRoleIdFromLocation } from './useRoleIdFromLocation';

function RoleDetailsPageContent(): React.JSX.Element {
  const roleId = useRoleIdFromLocation();
  const pageCtx = usePageContext();
  const canEditRole = useHasPermission('roles', 'update');

  return (
    <PageContent className={st.Body}>
      <RoleDetailsPageHeader />
      <RoleGeneralInfo
        actions={(
          canEditRole ? (
            <EditRoleButton
              roleId={roleId}
              size={pageCtx.buttonSize}
            />
          ) : undefined
        )}
        roleId={roleId}
      />
      <RolePermissions roleId={roleId} />
    </PageContent>
  );
}

function RoleDetailsPage(): React.JSX.Element {
  return (
    <Page>
      <RoleDetailsPageContent />
    </Page>
  );
}

export { RoleDetailsPage };
